import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import DataGrid from "../../components/dataGrid";
import { useDispatch, useSelector } from "react-redux";
import systemUserService from "../../services/systemUser";
import { selectUser, signOut } from "../../store/authSlice";
import { endLoading, startLoading } from "../../store/loadingSlice";
import { getErrorMessage } from "../../utils";
import systemUserColumns from "./columns";

const SystemUserView = () => {
  const [data, setData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [loadingData, setLoadingData] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const getAllUser = useCallback(async () => {
    try {
      setLoadingData(true);
      const { data } = await systemUserService.getAll();
      setData(data);
    } catch (err) {
      enqueueSnackbar(getErrorMessage(err), { variant: "error" });
    } finally {
      setLoadingData(false);
    }
  }, [enqueueSnackbar]);

  useEffect(() => {
    getAllUser();
  }, [getAllUser]);

  const onClickDelete = async (id) => {
    try {
      dispatch(startLoading());
      await systemUserService.remove(id);
      enqueueSnackbar("Remoção realizada com sucesso", {
        variant: "success",
      });
      id === user?.id ? dispatch(signOut()) : getAllUser();
    } catch (err) {
      enqueueSnackbar(getErrorMessage(err), { variant: "error" });
    } finally {
      dispatch(endLoading());
    }
  };

  return (
    <DataGrid
      rows={data}
      columns={systemUserColumns}
      editTo={(id) => `form/${id}`}
      onClickDelete={onClickDelete}
      loading={loadingData}
    />
  );
};

export default SystemUserView;
